import { ListAlt } from "@mui/icons-material";
import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import DropdownAnswerSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/DropdownAnswerSubtypeSummary";
import { DropdownAnswerSubtypeDataModel, DropdownAnswerSubtypeResponse } from "./dropdownAnswerSubtype";
import DropdownAnswerSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/DropdownAnswerSubtypeDetails";
import DropdownAnswerEditorPreview from "../../../components/actionModules/subtypes/dropdownAnswer/DropdownAnswerEditorPreview";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { ChecklistAnswerItem } from "./checklistAnswerSubtype";
import { ChecklistAnswerItemsEditor } from "../../../components/actionModules/subtypes/checklistAnswer/ChecklistAnswerItemsEditor";


export const DropdownAnswerSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.dropdownAnswer.name",
    type: Subtype.DropdownAnswerModuleSubtype,
    icon: <ListAlt />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<ListAlt />}
        name="actionModules.subtypes.dropdownAnswer.name" />,
    editorPreview: (state) => <DropdownAnswerEditorPreview state={state}/>,
    subtypeDataView: (props) => <DropdownAnswerSubtypeDetails
        subtype={props.subtype as DropdownAnswerSubtypeResponse}
        subtypeData={props.subtypeData as DropdownAnswerSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <DropdownAnswerSubtypeSummary
        subtype={props.subtype as DropdownAnswerSubtypeResponse}
        subtypeData={props.subtypeData as DropdownAnswerSubtypeDataModel} />,
    editableProperties: [
        {
            name: "checklistItems",
            displayName: "actionModules.subtypes.dropdownAnswer.checklistItems",
            propertyType: PropertyTypes.complex,
            defaultValue: [
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 1",
                    id: 1,
                },
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 2",
                    id: 2,
                },
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 3",
                    id: 3,
                },
            ] as ChecklistAnswerItem[],
            editor: (props) => <ChecklistAnswerItemsEditor {...props} />,
        },
    ]
};
